import { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2, Inbox, KeyRound } from "lucide-react";
import { Empty, StatusPill } from "../../components/common";
import { api, date, errMsg } from "../../lib/api";

const RentalRow = ({ r, onChanged }) => {
  const [pw, setPw] = useState(null);
  const [note, setNote] = useState(r.install_note || "");
  const [err, setErr] = useState("");
  const a = r.trading_account || {};
  const reveal = () => api.get(`/admin/rentals/${r.id}/trading-credentials`).then((x) => setPw(x.data.password)).catch((e) => setErr(errMsg(e, "Password tidak tersedia")));
  const mark = (status) => api.post(`/admin/rentals/${r.id}/install`, { status, note }).then(onChanged).catch((e) => setErr(errMsg(e, "Gagal menyimpan status")));
  return (
    <div className="table-row cols-5" data-testid={`admin-rental-row-${r.id}`}>
      <span>{r.member?.alias || r.member?.name}<small className="muted block">{r.member?.phone}</small></span>
      <span>{r.ea_name}<small className="muted block">s/d {date(r.end)}</small></span>
      <span>{a.platform ? `${a.platform} · ${a.login}` : "—"}<small className="muted block">{a.server || "akun belum diisi"}</small>
        {a.login && (pw ? <small className="code-hl block" data-testid={`admin-rental-password-${r.id}`}>{pw}</small> :
          <button className="text-button" onClick={reveal} data-testid={`admin-rental-reveal-${r.id}`}><KeyRound size={11} /> password</button>)}
      </span>
      <span><StatusPill status={r.install_status} testId={`admin-rental-status-${r.id}`} />{r.install_note && <small className="muted block">{r.install_note}</small>}</span>
      <span className="row-end">
        <input className="inline-input" placeholder="Catatan" value={note} onChange={(e) => setNote(e.target.value)} data-testid={`admin-rental-note-${r.id}`} />
        <button className="danger sm" onClick={() => mark("problem")} data-testid={`admin-rental-problem-${r.id}`} title="Tandai ada kendala" aria-label="Tandai ada kendala"><AlertTriangle size={13} /> Kendala</button>
        <button className="primary sm" onClick={() => mark("installed")} data-testid={`admin-rental-installed-${r.id}`}><CheckCircle2 size={13} /> Terpasang</button>
        {err && <small className="down block">{err}</small>}
      </span>
    </div>
  );
};

export default function AdminRentals() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("pending");
  const [tick, setTick] = useState(0);
  const [loadErr, setLoadErr] = useState("");
  useEffect(() => { api.get("/admin/rentals").then((r) => { setRows(r.data); setLoadErr(""); }).catch((e) => setLoadErr(errMsg(e, "Data sewa gagal dimuat"))); }, [tick]);
  const shown = rows.filter((r) => (filter === "pending" ? r.install_status !== "installed" : filter === "installed" ? r.install_status === "installed" : true));
  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">ADMIN · PEMASANGAN EA</p><h2>Sewa EA aktif</h2><p className="muted">Pasang EA di akun trading member, lalu tandai "Terpasang". Member menerima notifikasi email & WhatsApp.</p></div>
      </div>
      <div className="seg tabs">
        {[["pending", "Perlu dipasang"], ["installed", "Terpasang"], ["all", "Semua aktif"]].map(([v, l]) => (
          <button key={v} className={filter === v ? "active" : ""} onClick={() => setFilter(v)} data-testid={`admin-rental-filter-${v}`}>{l}</button>
        ))}
      </div>
      {loadErr && <div className="error" data-testid="admin-rentals-error">{loadErr}</div>}
      <section className="panel table-panel">
        {shown.length === 0 ? <Empty testId="admin-rentals-empty" icon={Inbox} title="Tidak ada sewa" text="Belum ada sewa EA pada filter ini." /> : (
          <>
            <div className="table-row cols-5 table-head"><span>MEMBER</span><span>EA</span><span>AKUN TRADING</span><span>STATUS</span><span>AKSI</span></div>
            {shown.map((r) => <RentalRow key={`${r.id}-${r.install_status}`} r={r} onChanged={() => setTick((t) => t + 1)} />)}
          </>
        )}
      </section>
    </>
  );
}
